import { useLinkResolver, useRuntimeConfig } from '#imports'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

/**
 * Provides Bouygues OAuth authorization URL
 *
 * @param authRouteName - The route name for the OAuth callback
 * @returns redirectUri and authorizeUrl for OAuth flow
 */
export function useBouyguesAuthorize(authRouteName: string) {
  const runtimeConfig = useRuntimeConfig()
  const { getLink } = useLinkResolver()
  const {
    market: { countryCode },
  } = useMarketplace()

  const clientId = runtimeConfig.public.BOUYGUES_TELECOM_OAUTH_CLIENT_ID

  const redirectUri = getLink({
    link: { name: authRouteName },
    countryCode,
  })?.href

  if (!redirectUri) throw new Error('Incorrect Bouygues oauth2 redirect_uri')

  const authorizeUrl = new URL(
    runtimeConfig.public.BOUYGUES_TELECOM_OAUTH_AUTHORIZE_ENDPOINT_URL,
  )

  authorizeUrl.searchParams.append('client_id', clientId)
  authorizeUrl.searchParams.append('response_type', 'code')
  authorizeUrl.searchParams.append('redirect_uri', redirectUri)

  return { redirectUri, authorizeUrl }
}
